import { render, staticRenderFns } from "./OrderHolderFilter.vue?vue&type=template&id=0ff24947&"
import script from "./OrderHolderFilter.vue?vue&type=script&lang=js&"
export * from "./OrderHolderFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports